
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter, ProductExpandTokens } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, PopulateApiParameter,DeferCallIfNecessary } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";


// get the type of props using this
interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
}

type displayProductsProps = Parameters<typeof DeferCallIfNecessary>[0];

function XCentiumPopulateApiParameter(props: displayProductsProps)  {
    const filters = props.result.productFilters;
    const {
        query,
        brandIds,
        productLineIds,
        priceFilters,
        attributeValueIds,
        searchWithinQueries,
        pageCategoryId,
        pageBrandId,
        pageProductLineId,
        ...apiParameter
    } = filters;
    props.apiParameter = {
        ...apiParameter,
        search: query,
        categoryId: filters.categoryId || filters.pageCategoryId,
        searchWithin: searchWithinQueries?.join(" "),
        includeSuggestions: filters.includeSuggestions !== false,
        brandIds: filters.pageBrandId ? [filters.pageBrandId] : brandIds,
        productLineIds: filters.pageProductLineId ? [filters.pageProductLineId] : productLineIds,
        priceFilters,
        attributeValueIds,
        expand: props.expandTokens || [],
        applyPersonalization: true,
        includeAttributes: ["includeOnProduct"],
        includeProductsInSubCategories: filters.pageCategoryId != null,
    } as XcGetProductCollectionApiV2Parameter;
};

export interface XcGetProductCollectionApiV2Parameter extends GetProductCollectionApiV2Parameter {
    includeProductsInSubCategories?: boolean;
}

replaceInChain(
    chain,
    PopulateApiParameter,
    XCentiumPopulateApiParameter
);